export default __webpack_public_path__ + "static/media/faci19.f1576d81.jpg";